import { Text } from '@mantine/core';
import { AssetFeedRowIcon } from 'src/financial/financial-data/AssetFeedIndicators';

const MAX_DESCRIPTION_LENGTH = 50;

type AssetDescriptionCellProps = {
  description?: string;
  isUpdatedAutomatically?: boolean;
  canConnectToFeed?: boolean;
};

export function AssetDescriptionCell({
  description,
  isUpdatedAutomatically,
  canConnectToFeed,
}: AssetDescriptionCellProps) {
  const text =
    description && description.length > MAX_DESCRIPTION_LENGTH
      ? description.slice(0, MAX_DESCRIPTION_LENGTH) + '...'
      : description;

  return (
    <>
      {text || (
        <Text c="gray.7" inherit>
          Unknown
        </Text>
      )}
      <AssetFeedRowIcon
        isUpdatedAutomatically={isUpdatedAutomatically}
        canConnectToFeed={canConnectToFeed}
      />
    </>
  );
}
